import {useEffect} from 'react';
import {scrollToQuiz, urlHasQuiz} from '../services/scrollToQuiz';

export const useQuizAutoScroll = () => {
  useEffect(() => {
    if (urlHasQuiz()) scrollToQuiz();
  }, []);
};
